<template>
    <div 
        :class="[sizeComputed, isDark ? 'hover:bg-gray-700/50' : 'hover:bg-gray-100']" 
        class="flex items-center justify-center rounded-lg p-2 transition-all duration-300 cursor-pointer"
        @click="toggleTheme"
    >
        <!-- Icona della luna (modalità dark) -->
        <span 
            class="material-symbols-outlined text-gray-400 transition-all duration-300 transform"
            :class="{'scale-100 opacity-100': isDark, 'scale-0 opacity-0': !isDark}"
        >
            dark_mode
        </span>

        <!-- Icona del sole (modalità light) -->
        <span 
            class="material-symbols-outlined text-yellow-500 transition-all duration-300 transform absolute"
            :class="{'scale-100 opacity-100': !isDark, 'scale-0 opacity-0': isDark}"
        >
            light_mode
        </span>
    </div>
</template>

<script setup>
import { computed, watch } from 'vue';
import { useDark, useToggle } from '@vueuse/core';

// Props
const props = defineProps({
    size: {
        type: String,
        default: 'md',
        validator: (value) => ['sm', 'md', 'lg', 'xs'].includes(value)
    }
});

// Size computed
const sizeComputed = computed(() => {
    const sizes = {
        xs: "w-6 h-6",
        sm: "w-8 h-8",
        md: "w-10 h-10",
        lg: "w-12 h-12"
    };
    return sizes[props.size] || sizes.md;
});

// Theme management
const isDark = useDark({
    selector: 'html',
    attribute: 'class',
    valueDark: 'dark',
    valueLight: 'light',
});

const toggleTheme = () => {
    isDark.value = !isDark.value;
    updateGradient();
};

// Update gradient based on theme
const updateGradient = () => {
    const body = document.querySelector('body');
    if (isDark.value) {
        body.classList.remove('gradient-light');
        body.classList.add('gradient-dark');
    } else {
        body.classList.remove('gradient-dark');
        body.classList.add('gradient-light');
    }
};

// Initialize gradient on mount
updateGradient();

// Watch for theme changes
watch(isDark, updateGradient, { immediate: true });
</script>

<style scoped>
.material-symbols-outlined {
    font-variation-settings: 'FILL' 1;
    position: absolute;
}
</style>